import "./BusinessAreas.module.css";
import Header from "@/reusable_sections/Header";
import Overview from "./sections/Overview";
import Geomancy from "./sections/Geomancy";
import Environment from "./sections/Environment";
import Footer from "@/reusable_sections/Footer";
export default function BusinessAreasPage() {
  return <div>
      <Header />
      <Overview />
      <Geomancy />
      <Environment />
      <Footer />
    </div>;
}